import { cn } from "../lib/utils";
import { TrendingUp, TrendingDown } from "lucide-react";

export function KpiCard({ label, value, sub, trend, tone = "default", className, testId }) {
  const toneClass = {
    default: "bg-white",
    alert: "bg-white border-freddy-red",
    muted: "bg-slate-50",
  }[tone];
  const trendColor =
    trend == null ? "" : trend >= 0 ? "text-verdict-strongText" : "text-verdict-passText";
  const TrendIcon = trend == null ? null : trend >= 0 ? TrendingUp : TrendingDown;

  return (
    <div
      data-testid={testId}
      className={cn(
        "relative rounded-xl border border-slate-200 p-5 flex flex-col gap-2",
        toneClass,
        className,
      )}
    >
      <div className="text-[11px] font-semibold text-slate-500 uppercase tracking-wider">
        {label}
      </div>
      <div className="text-3xl font-bold text-navy tabular leading-tight">
        {value}
      </div>
      {sub && <div className="text-xs text-slate-500 font-medium">{sub}</div>}
      {trend != null && TrendIcon && (
        <div className={cn("flex items-center gap-1 text-xs font-semibold", trendColor)}>
          <TrendIcon size={12} />
          <span>{trend >= 0 ? "+" : ""}{trend}% vs last week</span>
        </div>
      )}
    </div>
  );
}
